import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

import { GhLineIcon } from '../components/gh-line-icon.component';
import { IGhUspData } from './gh-usp.data';
import { IGhUspProps, IItemsData } from './gh-usp.props.autogenerated';

export interface IGhUspItemViewProps {
    key: string;
    icon: React.ReactNode;
    title: string;
    text?: string;
    href?: string;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IGhUspViewProps extends IGhUspProps<IGhUspData> {
    className: string;
    background: string;
    dividers: boolean;
    items: IGhUspItemViewProps[];
}

const customIconSettings: Msdyn365.IImageSettings = {
    viewports: {
        xs: { q: 'w=56&h=56&m=6', w: 56, h: 56 },
        lg: { q: 'w=56&h=56&m=6', w: 56, h: 56 }
    },
    lazyload: true
};

class GhUsp extends React.PureComponent<IGhUspProps<IGhUspData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        const items = (config.items ?? []).filter(item => item && item.title).map(this._toItemViewProps);

        if (items.length === 0 && !this.props.context.request.params?.isEditor) {
            return null;
        }

        const viewProps: IGhUspViewProps = {
            ...this.props,
            className: config.className ?? '',
            background: config.background ?? 'none',
            dividers: Boolean(config.dividers),
            items
        };

        return this.props.renderView(viewProps);
    }

    private readonly _toItemViewProps = (item: IItemsData, index: number): IGhUspItemViewProps => {
        const { customIcon, icon, title, text, link } = item;
        const hasImage = Boolean(customIcon && customIcon.src);

        return {
            key: `${index}-${title}`,
            icon: hasImage ? (
                <Msdyn365.Image
                    {...customIcon!}
                    altText=''
                    className='gh-usp__icon-image'
                    gridSettings={this.props.context.request.gridSettings!}
                    imageSettings={customIcon!.imageSettings ?? customIconSettings}
                    requestContext={this.props.context.request}
                    loadFailureBehavior='empty'
                />
            ) : (
                <GhLineIcon name={icon} className='gh-usp__icon-svg' />
            ),
            title,
            text: text || undefined,
            href: link?.linkUrl?.destinationUrl || undefined,
            ariaLabel: link?.ariaLabel || undefined,
            openInNewTab: link?.openInNewTab
        };
    };
}

export default GhUsp;
